export default {
    data() {
        return {
            rawData: [],
            dataHandled: [],
            pageNumber: 1,
            pageSize: 50,
            currentPage: 1,
            totalRow: 0
        }
    },
    watch: {
        rawData() {
            this.initRawData();
        }
    },
    methods: {
        // 初始化原始数据
        initRawData() {
            return this.handleData(1);
        },
        // 处理分页数据
        handleData(currentPage, pageSize = this.pageSize, rawData = this.rawData) {
            var offset = (currentPage - 1) * pageSize;
            this.dataHandled = (offset + pageSize >= rawData.length) ? rawData.slice(offset, rawData.length) : rawData.slice(
                offset, offset + pageSize);
        },
        // 跳转到X页
        handleCurrentChange(val) {
            this.currentPage = val;
            this.handleData(val)
        }
    }
}



// WEBPACK FOOTER //
// ./src/mixins/pagination.js